import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-2",
  "use": "icon-icon-nav-2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-2\"><path d=\"M713.6 176h-403.2c-36.928 0-67.2 30.272-67.2 67.2v537.6c0 36.992 30.272 67.2 67.2 67.2h403.2c36.928 0 67.2-30.272 67.2-67.2V243.2c0-36.928-30.272-67.2-67.2-67.2zM310.4 243.2h168V512l-84.032-50.368L310.4 512V243.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-2.svg
// module id = SxHw
// module chunks = 3